import React,{useState,useEffect,useRef} from 'react'
import {useLogin} from '../customhooks/useLogin'
import { Auth } from '../sdk';
export const Login=()=>{
  const [state,setState]=useState({
    email:"",
    password:"",
    error:"",
  })
  const [login]=useLogin();
  const ref=useRef();
  const handler=(event)=>{
  let key=event.target.name;
  let value=event.target.value;

  setState((pre)=>{
    return {...pre,[key]:value}
  })
  }
  const submit=async(event)=>{
    event.preventDefault();
    try{
      ref.current.disabled=true
      let data=await new Auth().login(state)
      login({token:data.tokenInfo.token,user:{email:data.userData.email,name:data.userData.userName,img:(data.userData.media.find(val=> val.mediaSpec ==="profile")).media_url,role:data.userData.userRole.name,permissions:data.userData.userRole.permissions,isHightAuthority:data.userData.isHightAuthority,
        desingnation:data.userData.desingnation,
        companyName:data.userData.companyName,
        departmentName:data.userData.departmentName,
      }});
      ref.current.disabled=false
    }catch(e){
      console.log(e)
      if(e.response.status===401){
        setState((pre)=>{
         return {...pre,error:"invalid Credentials"}
        })
        setTimeout(()=>{
          setState((pre)=>{
            return {...pre,error:""}
           })
        },5000)
      }
      else{
        alert("error occur")
      }
      ref.current.disabled=false
      //setState(p)   
    }
   
    
  }
  useEffect(()=>{
   window.$("#root").removeClass("app") 
   },[])
  return (
    <>
  <div className="row" style={{width:"99%"}}>
  <div className="col-sm-12 col-12">
<img src='assets/img/logo.png' style={{maxWidth:"180px",padding:"10px"}}/>
</div>
  </div>
   {/* Hello world */}
   <div className="login">
    {/* BEGIN login-content */}
    <div className="login-content">
      <form onSubmit={submit}>
        <h1 className="text-center">Welcome to Lakson AI System</h1>
        <div className="mb-3">
          <label className="form-label">
            Email Address <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control form-control-lg bg-white bg-opacity-5"
            name="email"
            value={state.email}
            onChange={handler}
            required
          />
        </div>
        <div className="mb-3">
          <div className="d-flex">
            <label className="form-label">
              Password <span className="text-danger">*</span>
            </label>
          
          </div>
          <input
            type="password"
            className="form-control form-control-lg bg-white bg-opacity-5"
            name="password"
            value={state.password}
            onChange={handler}
            required
          />
        </div>
        {state.error !=="" &&  <div className="alert alert-danger" role="alert" style={{padding:"11px"}}>{state.error}</div>}
        <button
          type="submit"
          className="btn btn-outline-theme btn-lg d-block w-100 fw-500 mb-3"
          ref={ref}
        >
          Sign In
        </button>
      
      </form>
    </div>
    {/* END login-content */}
  </div>
 {/* <div className="row" style={{paddingLeft: "10rem",marginTop:"8rem"}}>

<div className="col-sm-12 col-lg-12 col-12" style={{textAlign:"center"}}>
<h2 >Welcome to Colgate</h2>
</div>
<div className="col-12">
<form style={{width:"30%"}} onSubmit={submit}>
       
       
       <div className="mb-3">
         <label className="form-label">
           Email Address <span className="text-danger">*</span>
         </label>
         <input
           type="text"
           className="form-control form-control-lg bg-white bg-opacity-5"
           name="email"
           value={state.email}
           onChange={handler}
           required
         />
       </div>
       <div className="mb-3">
         <div className="d-flex">
           <label className="form-label">
             Password <span className="text-danger">*</span>
           </label>
          
         </div>
         <input
           type="password"
           className="form-control form-control-lg bg-white bg-opacity-5"
           name="password"
           value={state.password}
           onChange={handler}
           required
         />
       </div>
     
       {state.error !=="" &&  <div className="alert alert-danger" role="alert" style={{padding:"11px"}}>{state.error}</div>}
      
       <button
         type="submit"
         className="btn btn-outline-theme btn-lg d-block w-100 fw-500 mb-3"
         ref={ref}
       >
        
          Sign In
         
         
       </button>
     
     </form>
</div>
 </div> */}
  {/* <div className="login" style={{flexDirection:"column",paddingTop:"10rem"}}>
        <div style={{paddingLeft: "39rem"}}>
      <img src='assets/img/login_logo.jpeg' style={{width: "47%",height: "75%"}}/></div>
    <div>
    <h1 className="text-center">Welcome to Aletheia-Ai Footlytics</h1>
    </div>
    
    <div className="login-content">
   
      <form onSubmit={submit}>
       
       
        <div className="mb-3">
          <label className="form-label">
            Email Address <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control form-control-lg bg-white bg-opacity-5"
            name="email"
            value={state.email}
            onChange={handler}
            required
          />
        </div>
        <div className="mb-3">
          <div className="d-flex">
            <label className="form-label">
              Password <span className="text-danger">*</span>
            </label>
           
          </div>
          <input
            type="password"
            className="form-control form-control-lg bg-white bg-opacity-5"
            name="password"
            value={state.password}
            onChange={handler}
            required
          />
        </div>
      
        {state.error !=="" &&  <div className="alert alert-danger" role="alert" style={{padding:"11px"}}>{state.error}</div>}
       
        <button
          type="submit"
          className="btn btn-outline-theme btn-lg d-block w-100 fw-500 mb-3"
          ref={ref}
        >
         
           Sign In
          
          
        </button>
      
      </form>
    </div>
    
  </div> */}
  
 


    
    </>
  )
}
